export enum ScreenMonitoringType {
    AGENT_LEVEL = "AgentLevel",
    CONVERSATION_LEVEL = "ConversationLevel",
}

export default ScreenMonitoringType;
